import { ViewController } from '@estee/elc-service';
import { action, computed } from 'mobx';
import { UserRepository } from '../../repositories/UserRepository';
import { diContainer, serviceNames } from '../../../service-setup/diContainer';
import { ILogin } from '../../domain/entities/Login';
import { ReactFacebookLoginInfo } from 'react-facebook-login';
import { LoginType } from '../../../constants/LoginTypeEnum';
import { LoginSubmittedUseCase } from '../../../use-cases/LoginSubmittedUseCase';
import { ForgotPasswordUseCase } from '../../../use-cases/ForgotPasswordUseCase';

export class LoginViewController extends ViewController {
    public userRepository: UserRepository;

    constructor() {
        super();
        this.userRepository = diContainer.get(serviceNames.userRepository);
    }

    @computed
    private get formStore() {
        return this.userRepository.loginFormStore;
    }

    @action
    public setValues = (values: ILogin) => {
        this.formStore.values = values;
    };

    @computed
    public get data() {
        const {
            errorMessages,
            overlay: { isFormLoading }
        } = this.userRepository;

        return {
            formStore: this.formStore,
            errorMessages,
            isFormLoading
        };
    }

    @action
    public loginButtonClicked = async () => {
        const loginSubmittedUseCase = new LoginSubmittedUseCase(this.formStore.values);
        await loginSubmittedUseCase.execute();
    };

    @action
    public forgotPasswordClicked = () => {
        const forgotPasswordUseCase = new ForgotPasswordUseCase();
        forgotPasswordUseCase.execute();
    };

    @action
    public handleFacebookResponse = async ({ accessToken }: ReactFacebookLoginInfo) => {
        const loginSubmittedUseCase = new LoginSubmittedUseCase(
            { accessToken },
            LoginType.FACEBOOK
        );
        await loginSubmittedUseCase.execute();
    };
}
